import React from 'react';
import { useTranslation } from 'react-i18next';
import "./module-title-bar.scss";

interface ModuleTitleBarProps {
    titleText:string;
    haveSubtitle?:boolean;
    subtitleText?:string;
}

const ModuleTitleBar:React.FC<ModuleTitleBarProps> = ({
    titleText,
    haveSubtitle=false,
    subtitleText
}) => {

    const { t } = useTranslation();

    return (
        <div className='module-title-bar'>
            <div className="title mb-5">{titleText}</div>
            {haveSubtitle &&
                <div className="subtitle">{subtitleText}</div>
            }
        </div>
    )
}

export default ModuleTitleBar